export default __webpack_public_path__ + "static/media/hairy_bittercress.d0f888dc.jpeg";